import { useEffect, useState } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useTimeout } from "@/hooks/use-timers";

export function useReportedModal(): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
] {
  const [isOpen, setIsOpen] = useState(false);
  const { start: startReportedModalTimer } = useTimeout(
    () => setIsOpen(false),
    3000
  );

  useEffect(() => {
    if (isOpen) {
      startReportedModalTimer();
    }
  }, [isOpen, startReportedModalTimer]);

  return [isOpen, setIsOpen];
}

export default function ReportedModal(
  props: React.ComponentProps<typeof Dialog>
) {
  return (
    <Dialog {...props}>
      <DialogContent
        className="rounded-[15px] bg-twilight-indigo p-7.5 pb-6 shadow-0-0-20 shadow-deep-koamaru"
        onClick={() => props.onOpenChange?.(false)}
      >
        <div className="flex flex-col items-center">
          <svg
            aria-hidden="true"
            className="h-[15px] w-[21px] text-rose-red"
            fill="none"
            viewBox="0 0 21 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.03 5.92l6.366 6.367L18.971 1.713"
              stroke="currentColor"
              strokeWidth="3"
            />
          </svg>
          <h5 className="mt-4 text-center font-semibold text-14/[1.2em] text-white">
            User reported
          </h5>
          <p className="mt-2.5 text-center text-12/[2em] text-pale-lavender">
            Thanks for making the Morty community a better place
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
